export default __webpack_public_path__ + "static/media/README.11f7dd5b.md";